var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09911 7.65761C1.05049 7.73476 1.01905 7.82042 1.00637 7.91112L1 8.00338C1 8.08722 1.01665 8.17002 1.04877 8.24741L1.08942 8.32875C4.59579 13.889 11.4105 13.8866 14.901 8.34435C15.0232 8.15031 15.0319 7.91135 14.929 7.71147L14.8811 7.63259C11.4048 2.11795 4.59025 2.11866 1.09911 7.65761Z",
    stroke: "#A3B0B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99968 6C6.89556 6 6 6.89541 6 8C6 9.10413 6.89573 10 7.99968 10C9.10413 10 10 9.10427 10 8C10 6.89527 9.1043 6 7.99968 6Z",
    stroke: "#A3B0B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1L1 15",
    stroke: "#A3B0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye_hide.5896c8c0f34fbedf6862ffd1929d1152.svg";
export { ForwardRef as ReactComponent };